import { defineStore } from 'pinia';

export interface PusherConfig {
  apiKey: string;
  authUrl: string;
  channel: string;
  channelV5: string;
}
export interface SettingsStore {
  isCustomDomain?: boolean;
  customDomain?: string;
  loginUrl?: string;
  signupUrl?: string;
  baseUrl?: string;
  pusherConfig?: PusherConfig;
  baseDomain?: string;
  secondaryBaseDomain?: string;
  mcpServerUrl?: string;
  mcpSetupUrl?: string;
}

export const useSettingsStore = defineStore('settingsStore', {
  state: () =>
    ({
      pusherConfig: undefined,
      isCustomDomain: undefined,
      customDomain: undefined,
      loginUrl: undefined,
      signupUrl: undefined,
      baseUrl: undefined,
      baseDomain: undefined,
      secondaryBaseDomain: undefined,
      mcpServerUrl: undefined,
      mcpSetupUrl: undefined,
    }) as SettingsStore,

  actions: {
    initialize(data: any) {
      this.setIsCustomDomain(data.isCustomDomain);
      this.setCustomDomain(data.customDomain);
      this.setLoginUrl(data.loginUrl);
      this.setSignup(data.signupUrl);
      this.setBaseUrl(data.baseUrl);
      this.setBaseDomain(data.baseDomain);
      this.setSecondaryBaseDomain(data.secondaryBaseDomain);
      this.mcpServerUrl = data.mcpServerUrl;
      this.mcpSetupUrl = data.mcpSetupUrl;
    },
    setIsCustomDomain(input: boolean) {
      this.isCustomDomain = input;
    },
    setCustomDomain(domain: string) {
      this.customDomain = domain;
    },
    setLoginUrl(url: string) {
      this.loginUrl = url;
    },
    setSignup(url: string) {
      this.signupUrl = url;
    },
    setBaseUrl(url: string) {
      this.baseUrl = url;
    },
    getCopyItemUrl(itemId: String) {
      return `${this.baseUrl?.replace(/\/$/, '')}/items/${itemId}/copy`;
    },
    setPusherConfig(cfg: PusherConfig) {
      this.pusherConfig = cfg;
    },
    setBaseDomain(baseDomain: string) {
      this.baseDomain = baseDomain;
    },
    setSecondaryBaseDomain(secondaryBaseDomain: string) {
      this.secondaryBaseDomain = secondaryBaseDomain;
    },
  },
  getters: {
    pusher: (state: SettingsStore) => state.pusherConfig,
    // Returns the domain to use for generating links - custom domain if available, otherwise base URL
    effectiveDomain: (state: SettingsStore) => {
      return state.customDomain || state.baseUrl || '';
    },
  },
});
